// The Partes table's server filters (estado, proyecto, buscar), checked on a
// parte the page already has -- one changed or opened since the list was
// loaded. Without it, a parte cancelled or closed while "Abiertos" is
// filtered showed again: the server no longer sent it, so the table took it
// for a newly opened one. Mirrors routers/partes.py list_partes.
export function cumpleFiltros(p, params = {}) {
  const { estado, proyecto, buscar } = params
  if (estado === 'abierto' && !p.abierto) return false
  if (estado === 'cerrado' && (p.abierto || p.cancelado)) return false
  if (estado === 'cancelado' && !p.cancelado) return false
  if (proyecto && String(p.unidad_proyecto || '').toLowerCase() !== String(proyecto).toLowerCase()) return false
  const b = String(buscar || '').trim().toLowerCase()
  if (b) {
    const n = b.replace(/^#/, '')
    const coincide = String(p.nombre || '').toLowerCase().includes(b)
      || String(p.unidad_codigo || '').toLowerCase().includes(b)
      || (/^\d+$/.test(n) && String(p.numero) === n)
    if (!coincide) return false
  }
  return true
}
